import type { ChangeEvent, FC, HTMLAttributes, ReactElement, ReactNode } from 'react';

import type { CheckboxProps } from '@mui/material';
import { Checkbox, FormControl, FormControlLabel } from '@mui/material';

import { Field } from 'common/component/ValidationFormAndField';

import type { CIFieldProps } from './fields.interface';

export const CIMixedCheckBox: FC<CIFieldProps & CheckboxProps & HTMLAttributes<HTMLElement>> = (
    props
): ReactElement => {
    const { id, name, t, validations, labelI18NKey, value, onChange, ...rest } = props;

    return (
        <Field
            t={t}
            id={id}
            name={name}
            type="checkbox"
            validations={validations}
            value={value}
            render={({ input, meta }): ReactNode => {
                const customOnChange = (e: ChangeEvent<HTMLInputElement>): void => {
                    input.onChange(e);
                    onChange?.(e);
                };

                return (
                    <FormControl component="fieldset" error={meta.error && meta.touched}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    {...input}
                                    onChange={customOnChange}
                                    color="primary" // default to primary now, come back later if we need to have different colors
                                    {...rest}
                                />
                            }
                            label={labelI18NKey && t(labelI18NKey)}
                        />
                    </FormControl>
                );
            }}
        />
    );
};
